var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PageTitle',{attrs:{"title":"Upcoming Events"}}),_c('v-container',[_c('UpcomingEventsTable')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }